module.exports = require('./helpers/bundle-url').getBundleURL('fDqF5') + "logo.c51670a8.svg";